<template>
  <div class="container">
    <h1>Rules</h1>
    <div id="rules">
      <sdx-loading-spinner id="spinner-rules-content" size="large"
                           sr-hint="Loading. Please wait."></sdx-loading-spinner>
        <div id="sms_rules">
          <div class="sms-rules-table table table--responsive table--highlight margin-v-2">
            <div class="table_wrapper">
              <div v-for="routes in rulesContent" v-bind:key="routes">
                <span><strong>{{ routes.id + ': ' }}</strong>{{ routes.description }}</span>
                <table data-init="auto">
                  <thead>
                  <tr>
                    <th class="table-header">Rank</th>
                    <th class="table-header">Id</th>
                    <th class="table-header">Phone Number Prefix</th>
                    <th class="table-header">Adapter</th>
                    <th class="table-header">Rule Action</th>
                    <th class="table-header">Sent</th>
                    <th class="table-header">Last Update</th>
                  </tr>
                  </thead>
                  <div v-for="routes in rulesContent" v-bind:key="routes">
                  </div>
                  <tbody>
                  <tr v-for="(item) in routes.rules" v-bind:key="item" id="smsRulesTr">
                    <td>{{ item.rank }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.phoneNumberPrefix }}</td>
                    <td> {{ item.adapter }}</td>
                    <td>{{ item.ruleAction }}</td>
                    <td>{{ item.createdOn }}</td>
                    <td>{{ item.updatedOn }}</td>
                  </tr>
                  </tbody>
                </table>
                <br/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rulesContent.length === 0" class="no-items-found">
          <p><i>No rules found</i></p>
        </div>
        <div class="row justify-content-between">
        </div>
      </div>
    </div>
</template>

<script>
import rulesService from '../service'
import loadingSpinnerService from '@/services/loading-spinner.service';
import {logger} from "@/services/logger.service";
import {showAlert} from "@/services/notification.service";

export default {
  components: {},
  data: function () {
    return {
      webId: undefined,
      id: undefined,
      rulesContent: [],
      totalElements: -1,
      size: -1,
      page: [],
      showRules: false,
      isLoading: false,
    }
  },
  computed: {},
  async mounted() {
    loadingSpinnerService.show("rules")
    await this.loadData(1);
    loadingSpinnerService.hide("rules")
  },
  methods: {
    loadData: async function (page) {
      loadingSpinnerService.show("rules-content")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showRules = true;
        this.isLoading = true;

        try {
          let response = await rulesService.getRules(page - 1, 500, "createdOn,DESC");
          this.rulesContent = response.data;
          /*
          this.rulesContent = response.data.content;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.pageNumber;
          this.currentPage = response.data.number + 1;
          this.totalElements = response.data.totalElements;
          this.size = response.data.size;
          */
          logger.debug('response: ' + this.rulesContent);
        } catch (error) {
          this.rulesContent = []
          showAlert(error.message)
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("rules-content");
    },
    watch: {
      page: function () {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style>
.sms-rules-table {

}

.sms-rules-table .table-header {
  padding-top: 20px;
  padding-bottom: 17px;
}

.sms-rules-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

</style>
